import React from 'react';
import { motion } from 'framer-motion';
import { ArrowUpRight } from 'iconoir-react';

const DexterityFactions: React.FC = () => {
  return (
    <div className="relative w-full min-h-screen flex items-center justify-center overflow-hidden">
      {/* Video Background - zoomed out */}
      <div className="absolute inset-0 z-0">
        <video
          className="absolute w-full h-full object-cover scale-110"
          autoPlay
          muted
          loop
          playsInline
        >
          <source src={`${process.env.PUBLIC_URL}/dexterityfactions.mp4`} type="video/mp4" />
        </video>
        {/* Gradient overlay */}
        <div className="absolute inset-0 bg-gradient-to-r from-black/70 via-black/50 to-black/70" />
      </div>

      {/* Content */}
      <div className="relative z-10 w-full max-w-6xl mx-auto p-4 md:p-8">
        <div className="flex justify-end">
          {/* Card */}
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6 }}
            className="w-full max-w-sm"
          >
            {/* Section Label */}
            <span className="text-neutral-400 text-sm font-mono tracking-wide mb-4 block">
              04 — ENTREPRENEURSHIP
            </span>

            {/* Card Content */}
            <div className="bg-white/95 backdrop-blur-sm rounded-xl border border-neutral-200 overflow-hidden">
              {/* Header with logo */}
              <div className="p-5 border-b border-neutral-100">
                <div className="flex items-center gap-3 mb-3">
                  <img
                    src={`${process.env.PUBLIC_URL}/Dexterity-Factions-Logo.webp`}
                    alt="Dexterity Factions"
                    className="w-10 h-10 rounded-lg object-cover"
                  />
                  <div>
                    <h2 className="font-semibold text-slate-900">Dexterity Factions</h2>
                    <p className="text-neutral-400 text-xs">Founder & Operator • 2016 - 2020</p>
                  </div>
                </div>
                <p className="text-neutral-600 text-sm leading-relaxed">
                  Built and scaled a multiplayer gaming platform from zero to 100+ concurrent daily users with sustainable revenue.
                </p>
              </div>

              {/* Stats Row */}
              <div className="grid grid-cols-3 divide-x divide-neutral-100 bg-neutral-50">
                <div className="p-3 text-center">
                  <div className="text-lg font-bold text-slate-900">100+</div>
                  <div className="text-[10px] text-neutral-500 uppercase">Daily Active</div>
                </div>
                <div className="p-3 text-center">
                  <div className="text-lg font-bold text-slate-900">4 yrs</div>
                  <div className="text-[10px] text-neutral-500 uppercase">Runtime</div>
                </div>
                <div className="p-3 text-center">
                  <div className="text-lg font-bold text-slate-900">$$$</div>
                  <div className="text-[10px] text-neutral-500 uppercase">Revenue</div>
                </div>
              </div>

              {/* Responsibilities */}
              <div className="p-5 space-y-2">
                <p className="text-[10px] text-neutral-400 uppercase tracking-wider font-medium mb-3">What I Built</p>
                <div className="space-y-2 text-sm text-neutral-600">
                  <div className="flex gap-2">
                    <span className="text-neutral-300">→</span>
                    <span>Led team of developers and support agents</span>
                  </div>
                  <div className="flex gap-2">
                    <span className="text-neutral-300">→</span>
                    <span>Managed Linux servers with 99.9% uptime SLA</span>
                  </div>
                  <div className="flex gap-2">
                    <span className="text-neutral-300">→</span>
                    <span>Developed custom Java plugins and game mechanics</span>
                  </div>
                  <div className="flex gap-2">
                    <span className="text-neutral-300">→</span>
                    <span>Designed monetization through in-game store</span>
                  </div>
                </div>
              </div>

              {/* Tech Stack */}
              <div className="px-5 pb-4">
                <div className="flex flex-wrap gap-1.5">
                  {['Java', 'MySQL', 'Linux', 'Spigot API', 'BungeeCord', 'Discord'].map((tech) => (
                    <span
                      key={tech}
                      className="px-2 py-0.5 rounded text-[10px] font-medium bg-neutral-100 text-neutral-500"
                    >
                      {tech}
                    </span>
                  ))}
                </div>
              </div>

              {/* See More Link */}
              <a
                href="https://docs.google.com/document/d/1UclQ-KP7IHW8JLyWGvP1rTSNPH4oAHEwMNfy-OoemPw/edit?usp=sharing"
                target="_blank"
                rel="noopener noreferrer"
                className="flex items-center justify-center gap-2 p-3 bg-neutral-50 border-t border-neutral-100 text-sm text-neutral-600 hover:text-slate-900 hover:bg-neutral-100 transition-colors"
              >
                See project documentation
                <ArrowUpRight width={14} height={14} />
              </a>
            </div>
          </motion.div>
        </div>
      </div>
    </div>
  );
};

export default DexterityFactions;
